import axios from 'axios';
import { GET_PENDING_PAYMENT_ENDPOINT, GET_GENERATED_PAYMENT_LINK_ENDPOINT } from '../constants/endpoint';

const GetPendingPayment = async prospectId => {
  try {
    const { data } = await axios.get(`${GET_PENDING_PAYMENT_ENDPOINT}/${prospectId}`);
    return data;
  } catch (err) {
    const message = err.response?.data?.message;
    throw message || err;
  }
};

const GetGeneratedPaymentLink = async prospectId => {
  try {
    const { data } = await axios.get(`${GET_GENERATED_PAYMENT_LINK_ENDPOINT}/${prospectId}`);
    return data;
  } catch (err) {
    const message = err.response?.data?.message;
    throw message || err;
  }
};

export { GetPendingPayment, GetGeneratedPaymentLink };
